module.exports = __webpack_public_path__ + "img/theater-email-create.73d9de99.svg";